export interface Module {
  id: number;
  name: string;
  iconUrl: string;
  markers: {
    default: string;
    selected: string;
  };
}

export const ModuleType = {
  WaterSupply: {
    id: 4,
    name: "Abastecimento de Água",
    iconUrl: "/assets/ic_modules/ic_water_supply.svg",
    markers: {
      default: "/assets/markers/marker_water_default.svg",
      selected: "/assets/markers/marker_water_selected.svg"
    }
  },
  TreePruning: {
    id: 12,
    name: "Corte e Poda de Árvores",
    iconUrl: "/assets/ic_modules/ic_tree_pruning.svg",
    markers: {
      default: "/assets/markers/marker_tree_cutting_and_pruning_default.svg",
      selected: "/assets/markers/marker_tree_cutting_and_pruning_selected.svg"
    }
  },
  DebrisCollection: {
    id: 5,
    name: "Coleta de Entulho",
    iconUrl: "/assets/ic_modules/ic_debris_collection.svg",
    markers: {
      default: "assets/markers/marker_debris_collection_default.svg",
      selected: "assets/markers/marker_debris_collection_selected.svg"
    }
  },
  GarbageCollection: {
    id: 6,
    name: "Coleta de Lixo",
    iconUrl: "/assets/ic_modules/ic_garbage_collection.svg",
    markers: {
      default: "/assets/markers/marker_garbage_collection_default.svg",
      selected: "/assets/markers/marker_garbage_collection_selected.svg"
    }
  },
  AnimalControl: {
    id: 15,
    name: "Controle de Animais",
    iconUrl: "/assets/ic_modules/ic_animal_control.svg",
    markers: {
      default: "/assets/markers/marker_animal_control_default.svg",
      selected: "/assets/markers/marker_animal_control_selected.svg"
    }
  },
  ReportCrime: {
    id: 18,
    name: "Denunciar Crime",
    iconUrl: "/assets/ic_modules/ic_report_crime.svg",
    markers: {
      default: "/assets/markers/marker_report_crime_default.svg",
      selected: "/assets/markers/marker_report_crime_selected.svg"
    }
  },
  MunicipalConsortium: {
    id: 3,
    name: "Consórcio Municipal",
    iconUrl: "/assets/ic_modules/ic_municipal_consortium.svg",
    markers: {
      default: "/assets/markers/marker_municipal_consortium_default.svg",
      selected: "/assets/markers/marker_municipal_consortium_selected.svg"
    }
  },
  DengueOutbreaks: {
    id: 9,
    name: "Focos de Dengue",
    iconUrl: "/assets/ic_modules/ic_dengue_outbreaks.svg",
    markers: {
      default: "/assets/markers/marker_dengue_outbreak_default.svg",
      selected: "/assets/markers/marker_dengue_outbreak_selected.svg"
    }
  },
  PublicIllumination: {
    id: 1,
    name: "Iluminação Pública",
    iconUrl: "/assets/ic_modules/ic_public_illumination.svg",
    markers: {
      default: "/assets/markers/marker_public_lighting_default.svg",
      selected: "/assets/markers/marker_public_lighting_selected.svg"
    }
  },
  RoadMaintenance: {
    id: 7,
    name: "Manutenção de Ruas",
    iconUrl: "/assets/ic_modules/ic_road_maintenance.svg",
    markers: {
      default: "/assets/markers/marker_street_maintenance_default.svg",
      selected: "/assets/markers/marker_street_maintenance_selected.svg"
    }
  },
  OtherMaintenance: {
    id: 8,
    name: "Outras Manutenções",
    iconUrl: "/assets/ic_modules/ic_other_maintenance.svg",
    markers: {
      default: "/assets/markers/marker_other_maintenance_default.svg",
      selected: "/assets/markers/marker_other_maintenance_selected.svg"
    }
  },
  OtherComplaints: {
    id: 14,
    name: "Outras Reclamações",
    iconUrl: "/assets/ic_modules/ic_other_complaints.svg",
    markers: {
      default: "/assets/markers/marker_other_complaints_default.svg",
      selected: "/assets/markers/marker_other_complaints_selected.svg"
    }
  },
  NoisePollution: {
    id: 13,
    name: "Poluição Sonora",
    iconUrl: "/assets/ic_modules/ic_noise_pollution.svg",
    markers: {
      default: "/assets/markers/marker_noise_pollution_default.svg",
      selected: "/assets/markers/marker_noise_pollution_selected.svg"
    }
  },
  VariousComplaints: {
    id: 11,
    name: "Reclamações Diversas",
    iconUrl: "/assets/ic_modules/ic_various_complaints.svg",
    markers: {
      default: "/assets/markers/marker_various_complaints_default.svg",
      selected: "/assets/markers/marker_various_complaints_selected.svg"
    }
  },
  BasicSanitation: {
    id: 10,
    name: "Saneamento Básico",
    iconUrl: "/assets/ic_modules/ic_basic_sanitation.svg",
    markers: {
      default: "/assets/markers/marker_basic_sanitation_default.svg",
      selected: "/assets/markers/marker_basic_sanitation_selected.svg"
    }
  },
  PublicSecurity: {
    id: 2,
    name: "Segurança Pública",
    iconUrl: "/assets/ic_modules/ic_public_security.svg",
    markers: {
      default: "/assets/markers/marker_public_security_default.svg",
      selected: "/assets/markers/marker_public_security_selected.svg"
    }
  },
  ConsumerUnit: {
    id: 17,
    name: "Unidade Consumidora",
    iconUrl: "/assets/ic_modules/ic_consumer_unit.svg",
    markers: {
      default: "/assets/markers/marker_consumer_default.svg",
      selected: "/assets/markers/marker_consumer_selected.svg"
    }
  },
} as const;

export const modules: Module[] = Object.values(ModuleType);

export function getAvailableModules(availableIds: number[]): Module[] {
  return modules.filter(module => availableIds.includes(module.id));
}

export function getModuleById(id: number): Module {
  const module = modules.find(module => module.id === id);
  if (!module) {
    throw new Error(`Module with id ${id} not found`);
  }
  return module;
}

export function getModuleNameById(id: number): string {
  const module = getModuleById(id);
  return module.name;
}

export function getModuleIconById(id: number): string {
  const module = getModuleById(id);
  return module.iconUrl;
}

export function getIconDefaultById(id: number): string {
  const module = getModuleById(id);
  return module.markers.default;
}
export function getIconSelectedById(id: number): string {
  const module = getModuleById(id);
  return module.markers.selected;
}

export function getMarkerIconUrl(markerName: string): string {
  return `/assets/markers/${markerName}.svg`;
}